export const defaultReconnectChatPaneButtonGroupStyles = {
  alignItems: "stretch"
};